export const defaultCellSpacing = 3;
export const headerCellHeight = '56px';
export const footerCellHeight = '56px';
//# sourceMappingURL=constants.js.map